import { SecondaryProductSummarySkeleton } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary.skeleton';
import { SecondaryTradeInformationSkeleton } from 'components/secondaryMarket/shared/sections/SecondaryTradeInformation.skeleton';
import { FC } from 'react';

export const DlpOrderFormContentSkeleton: FC = () => (
  <>
    <SecondaryProductSummarySkeleton />
    <SecondaryTradeInformationSkeleton />
  </>
);
